import ztComponent from './ztOverlay.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
